'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var GoogleAnalytics = exports.GoogleAnalytics = function () {
  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);
  }

  _createClass(GoogleAnalytics, null, [{
    key: 'inject',
    value: function inject() {
      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    }
  }, {
    key: 'initialize',
    value: function initialize(trackingId, userId) {
      var ga = window.ga;

      if (ga === undefined) {
        GoogleAnalytics.inject();
      }

      this._ga = window.ga;
      ga = this._ga; // userId must be a string

      ga('create', trackingId, 'auto', {
        userId: userId + ''
      });
    }
    /**
     * Sets key-value options for events
     * @param {Object} opts Options to pass to google analytics
     */

  }, {
    key: 'set',
    value: function set(opts) {
      this._ga('set', opts);
    }
    /**
     * Sends pageview event
     * @param {path} path to send to google analytics
     */

  }, {
    key: 'pageview',
    value: function pageview() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;

      this._ga('send', 'pageview', path);
    }
  }, {
    key: 'send',
    value: function send(event, opt) {
      this._ga(event, opt);
    }
  }]);

  return GoogleAnalytics;
}();